import { render, staticRenderFns } from "./ZaloChatBox.vue?vue&type=template&id=5751db66&scoped=true"
import script from "./ZaloChatBox.vue?vue&type=script&lang=js"
export * from "./ZaloChatBox.vue?vue&type=script&lang=js"
import style0 from "./ZaloChatBox.vue?vue&type=style&index=0&id=5751db66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5751db66",
  null
  
)

export default component.exports